<template>
  <div class="home">
    <van-nav-bar
      left-arrow
      fixed
      :title="$t('print.name')"
      @click-left="$router.go(-1)"
    >
    </van-nav-bar>
    <!-- <van-icon
        name="./static/img/ok.png"
        slot="right"
        @click="addPrinter()"
        style="font-size: 24px"
      /> -->

    <van-cell-group>
      <template v-for="(item, index) in list">
        <van-cell :title="item.title" is-link @click="changedialog(index)" />
      </template>
    </van-cell-group>
    <van-cell-group>
      <!-- <van-field
        v-model="printer.title"
        :label="$t('print.title')"
        :placeholder="$t('print.title')"
        clearable
      />
      <van-field
        v-model="printer.stand"
        :label="$t('print.stand')"
        :placeholder="$t('print.stand')"
        clearable
      />
      <van-field
        v-model="printer.number"
        :label="$t('print.number')"
        :placeholder="$t('print.number')"
        clearable
      /> -->
    </van-cell-group>

    <van-popup
      v-model="showSelect"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <van-picker
        show-toolbar
        :columns="selectVal"
        @cancel="showSelect = false"
        @confirm="editSelect"
        :confirm-button-text="$t('vantText.confirm')"
        :cancel-button-text="$t('vantText.cancel')"
      />
    </van-popup>
    <!-- 底部彈窗，選擇標籤 -->
    <van-popup v-model="tagSelect" position="bottom" :style="{ height: '40%' }">
      <!-- <div class="style_title">{{ $t("printerSet.ptitle") }}</div> -->
      <van-cell-group style="margin-top: 20px">
        <van-field
          v-model="ctitle"
          :label="$t('platform.name')"
          clearable
          :placeholder="$t('EditShop.inputName')"
        />
      </van-cell-group>
      <div class="style_title" style="padding-bottom: 0">
        {{ $t("printerSet.tagTitle") }}
      </div>
      <div class="tagsWrap">
        <van-checkbox-group
          v-model="tagsArray"
          direction="horizontal"
          @change="changeBox"
        >
          <van-checkbox
            v-for="(item, key) in tagdArr"
            :name="item.id"
            :key="key"
            shape="square"
            >{{ item.name }}</van-checkbox
          >
        </van-checkbox-group>
      </div>
      <!-- 提交按钮 -->
      <div class="bottom">
        <van-button
          class="issueBtn"
          round
          type="default"
          style="font-weight: bold; font-size: 16px"
          @click="submit"
          >{{ $t("ShopStatus.certain") }}
        </van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      printer: {
        title: "后厨单",
        stand: "台位",
        number: "单号"
      },
      showSelect: false,
      tagSelect: false,
      selectVal: ["左边排列", "右边排列", "两边排列"],
      list: [],
      tagdArr: [],
      tagsArray: [],
      clickindex: "",
      submitArr: [],
      ctitle: ""
    };
  },
  mounted: function() {
    this.getTagsList();
    this.getinfo();
  },
  methods: {
    editSelect(value) {
      this.showSelect = false;
      // this.printer = value;
    },
    getTagsList() {
      //   查看樣式列表
      this.$axios({
        method: "GET",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/chefprints/" +
          sessionStorage.getItem("actShopId") +
          "/list",
        data: null
      })
        .then(res => {
          console.log(res.data.data);
          if (res.data.status == 200) {
            this.tagdArr = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditShop.message")
          });
        });
    },
    getinfo() {
      // 如果选择了打包外卖堂食类型
      if (this.$route.query.kitchenv) {
        // 如果是后厨
        if (this.$route.query.type == "kitchen") {
          this.getOrderInfo("chefprints");
          // 如果是订单（收银、结账、加菜）
        } else if (
          this.$route.query.type == "cash" ||
          this.$route.query.type == "order" ||
          this.$route.query.type == "addmenu"
        ) {
          this.getOrderInfo("orderprints");
        }
      } else {
        console.log("交接班");
        var ajaxdata = {
          store_id: sessionStorage.getItem("actShopId")
        };
        this.$axios({
          method: "POST",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/handoverprints/index",
          data: ajaxdata
        })
          .then(res => {
            // console.log(res);
            if (res.data.status == 200) {
              this.list = res.data.data;
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("EditShop.message")
            });
          });
      }
    },
    getOrderInfo(ajaxtype) {
      var ajaxdata = {
        store_id: sessionStorage.getItem("actShopId"),
        type: this.$route.query.kitchenv
      };
      this.$axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/" + ajaxtype + "/index",
        data: ajaxdata
      })
        .then(res => {
          console.log(res.data.data[0]);
          if (res.data.status == 200) {
            this.list = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditShop.message")
          });
        });
    },
    changedialog(index) {
      console.log(index, "点击的索引");
      this.clickindex = index;
      this.tagSelect = true;
      this.ctitle = this.list[index].title;
      var style_tags = this.list[index].style_tag;
      var newA = [];
      style_tags.forEach(d => {
        newA.push(Number(d));
      });
      this.tagsArray = newA;
    },
    // 保存打印机设置
    addPrinter() {},
    savePrinter(data) {
      this.$axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/storeprinter/addPrinters",
        data: data
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            const vm = this;
            setTimeout(function() {
              vm.$router.push("/PrinterList");
            }, 1000);
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditShop.message")
          });
        });
    },
    saveEdit(ajaxtype) {
      console.log(this.clickindex, "点击的索引");
      console.log(this.list[this.clickindex]);
      console.log(this.submitArr);
      var ajaxdata = {
        id: this.list[this.clickindex].id,
        title: this.ctitle,
        style_tag: this.submitArr
      };
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/" + ajaxtype + "/update",
        data: ajaxdata
      })
        .then(res => {
          console.log(res.data.data);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.getinfo();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditShop.message")
          });
        });
    },
    submit() {
      // 如果选择了打包外卖堂食类型
      if (this.$route.query.kitchenv) {
        // 如果是后厨
        if (this.$route.query.type == "kitchen") {
          this.saveEdit("chefprints");
          // 如果是订单（收银、结账、加菜）
        } else if (
          this.$route.query.type == "cash" ||
          this.$route.query.type == "order" ||
          this.$route.query.type == "addmenu"
        ) {
          this.saveEdit("orderprints");
        }
      }
    },
    changeBox(val) {
      // 把选中的值存在data，用于提交
      console.log(this.tagsArray);
      this.submitArr = val;
    }
  }
};
</script>
<style scoped>
.tagsWrap {
  padding: 10px;
  display: flex;
  align-items: flex-start;
}
.style_title {
  padding: 10px;
}
.bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  background: #fff;
}
.issueBtn {
  width: 90%;
  position: absolute;
  left: 50%;
  top: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
  background: #000;
}
/deep/ .van-checkbox--horizontal {
  margin-top: 10px;
  width: 40%;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 20px;
}
/deep/ .van-cell .van-icon {
  font-size: 20px;
}
/deep/ .van-field__control {
  text-align: right;
}
.delBtn {
  width: auto;
  padding: 4px 10px;
  color: #fff;
  font-size: 14px;
  line-height: 16px;
  position: absolute;
  top: -32px;
  right: 16px;
  background-color: #ee0a24;
  border-radius: 5px;
}
/deep/ .van-button--normal {
  border-radius: 5px;
}
.home {
  width: 100%;
  /*height: 100vh;*/
  background: #f3f5f7;
  padding-bottom: 10px;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f4;
}
/deep/ .van-cell-group {
  background: #f3f5f7;
}
/deep/ .van-field__control {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/Print/PrintSet.vue